import React, { Suspense } from "react";
import PropTypes from "prop-types";
import LoadingBoundary from "components/layout/LoadingBoundary";
import Loader from "components/layout/Loader";
import ErrorBoundary from "components/layout/ErrorBoundary";

export default function AsyncLoadContainer({
    children,
    className,
    fallback = <Loader />,
}) {
    return (
        <LoadingBoundary className={className}>
            <ErrorBoundary>
                <Suspense fallback={fallback}>
                    {children}
                </Suspense>
            </ErrorBoundary>
        </LoadingBoundary>
    );
}

AsyncLoadContainer.propTypes = {
    className: PropTypes.any,
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};
